module.exports = __webpack_public_path__ + "static/media/nexone-clutch-award.16f4b069.png";